import React from 'react';
import styles from "./Processing.module.scss";
import {withRouter} from 'react-router-dom';
import {Loading} from "@onegovbugs/onegov-react-components";

const Processing = props => {
  return <div className={`${styles.mainCont} ${styles.mainContWide}`}>
    <div className={`row`}>
      <div className={`col-12`}>
        <Loading className={styles.loading} label={props.message || "Loading"} type={'ajax'}/>
      </div>
    </div>
  </div>;
};

export default withRouter(props => <Processing {...props} />);
